import { useSmartsupp } from './useSmartsupp'

function SmartsUpp() {
  useSmartsupp()

  return null
}

export { SmartsUpp }
